import React from 'react';
import PropTypes from 'prop-types';
import global from '../../stores/GlobalStore';
import 'react-activity-feed/dist/index.css';

import { calculateZoom } from '../../utils/podcastUtils';

import AudioClipper from '../ClippEmbedPlayer/AudioClipper';
import EmbedPlayerContainer from '../ClippPlayer/EmbedPlayerContainer';

import './styles/AudioPlayer.scss';

export default class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.allowPlaylists = false;

    this.state = {
      isLoading: true,
      audioClipper: false,
      showPlaylist: false,
    };
  }

  componentDidMount() {
    window.addEventListener('EPISODE_PEAKS_LOADED', this.peaksLoaded);
  }

  componentWillUnmount() {
    window.removeEventListener('EPISODE_PEAKS_LOADED', this.peaksLoaded);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.episodeId !== newProps.episodeId) {
      this.loadEpisode(newProps.episodeId, true);
    }
  }

  loadEpisode = (episodeId, forceReload) => {
    global()
      .getPodcastStore()
      .fetchEpisode(episodeId, episode => {
        // TODO: This should alert the user, ask if they want to listen now or add to queue
        if (episode.id !== this.props.episode.id || forceReload) {
          this.setState({ audioClipper: false });
          this.props.setActiveEpisode(episode);
        }
      });
  };

  peaksLoaded = ({ detail }) => {
    if (detail === this.props.episode.id && !this.props.episode.audioData) {
      setTimeout(() => {
        this.loadEpisode(detail, true);
      }, 500);
    }
  };

  renderAudioPlayer = episode => {
    return (
      episode.audioUrl && (
        <EmbedPlayerContainer
          {...this.props}
          toggleAudioClipper={this.toggleAudioClipper}
          audioDetails={{
            audioUrl: episode.audioUrl,
            audioPeaks: episode.audioData || [],
            duration: episode.duration,
            zoom: calculateZoom(episode.duration),
          }}
        />
      )
    );
  };

  renderAudioClipper = episode => {
    return (
      episode.audioUrl && (
        <AudioClipper
          {...this.props}
          toggleAudioClipper={this.toggleAudioClipper}
          audioDetails={{
            audioUrl: episode.audioUrl,
            audioPeaks: episode.audioData || [],
            duration: episode.duration,
            zoom: calculateZoom(episode.duration),
          }}
        />
      )
    );
  };

  toggleAudioClipper = () => {
    this.setState({ audioClipper: !this.state.audioClipper });
  };

  openPlaylist = () => {
    console.log('opened');
    this.setState({ showPlaylist: !this.state.showPlaylist });
  };

  render() {
    const { episode, playerExpanded, isMobile } = this.props;
    const { showPlaylist } = this.state;

    return (
      <div>
        {this.allowPlaylists && (
          <div>
            <div className={`playlist-tab ${showPlaylist ? 'extended' : ''}`} onClick={this.openPlaylist}>
              <div>Queue</div>
            </div>
            {showPlaylist && (
              <div className='playlist-panel'>
                <div>Up Next...</div>
                <div>GaryVee Audio Experience</div>
                <div>iPhone's Amazing New Camera, Tesla vs Porsche Round 2, & Google Pixel 4 Leaks</div>
              </div>
            )}
          </div>
        )}
        <div
          className='audio-player'
          style={{
            height: playerExpanded ? (isMobile ? '111px' : '155px') : '60px',
          }}
        >
          {this.state.audioClipper ? this.renderAudioClipper(episode) : this.renderAudioPlayer(episode)}
        </div>
      </div>
    );
  }
}

AudioPlayer.propTypes = {
  user: PropTypes.object,
  episodeId: PropTypes.string.isRequired,
  episode: PropTypes.object.isRequired,
  show: PropTypes.object.isRequired,
  setActiveEpisode: PropTypes.func.isRequired,
  playerExpanded: PropTypes.bool.isRequired,
  togglePlayer: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};

AudioPlayer.defaultProps = {
  episodeId: '',
  episode: {},
};
